// ---------------------------------------------------------------------------
// Who curates, rather than consumes.
//
//   admin        platform operator
//   prime seller the staff account that does the first, careful listing of a
//                product — the one every later seller inherits
//
// The same pair the backend gates on in middleware/requireCurator.js, and the
// same pair config/plans.js exempts from billing. Kept as one function here so
// the three screens that care cannot drift apart, and so adding a role later
// is one edit rather than a search.
//
// This is a PRESENTATION check. It decides which flow a screen offers, not
// what anyone is allowed to do — every real permission is enforced server-side,
// because a role read out of localStorage is a role a user can edit.
// ---------------------------------------------------------------------------
export const isCurator = (user) => Boolean(
  user && (user.role === 'admin' || user.isPrimeSeller === true)
);

// Curators author the source listing by hand.
//
// Their images, title and description are what FILL the shared tanks. Running
// them through an assistant that reads from those tanks would have them
// copying out of the pool they are meant to be seeding, so they get the form
// the assistant was built to replace for everyone else.
export const fillsListingsManually = isCurator;
